export default __webpack_public_path__ + "static/media/230.9ea852f8.png";